export const RELOAD_ON_TAB_RETURN_MIN_INTERVAL = 5000
